import { render } from "./KioskWaitingRoomOverlay.vue?vue&type=template&id=a26ea512&scoped=true&ts=true"
import script from "./KioskWaitingRoomOverlay.vue?vue&type=script&lang=ts"
export * from "./KioskWaitingRoomOverlay.vue?vue&type=script&lang=ts"

import "./KioskWaitingRoomOverlay.vue?vue&type=style&index=0&id=a26ea512&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a26ea512"]])

export default __exports__